export const BASE_URL = `${window.location.protocol}//${window.location.hostname}/StarComputer/backend`;
export const BASE_URL1 = `${window.location.protocol}//${window.location.hostname}/StarComputer/backend/`;
